var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStars24(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.33325 8C1.33325 4.32 4.31325 1.33334 7.99325 1.33334C11.6799 1.33334 14.6666 4.32 14.6666 8C14.6666 11.68 11.6799 14.6667 7.99325 14.6667C4.31325 14.6667 1.33325 11.68 1.33325 8ZM7.99992 10.3L10.8199 12L10.0733 8.78667L12.5599 6.63334L9.27992 6.35334L7.99992 3.33334L6.71992 6.36L3.43992 6.64L5.92658 8.79333L5.17992 12L7.99992 10.3Z",
    fill: "#FC7753"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStars24);
export default __webpack_public_path__ + "static/media/Stars_24.0272958bc31c504ef851f9075e4726b9.svg";
export { ForwardRef as ReactComponent };